<div class="advertisement_map_details">
    <div class="map_management">
        <div class="custom_container">
            <ul class="list_none tabs border_r text-center d-flex flex-column flex-sm-row">
                <li 
                    class="border_r label_lg_bold" 
                    [ngClass]="{'active': MapOption == 0}" 
                    (click)="MapOption = 0; AdvertisementCardModel = null; setCenterMap()"
                >
                    <img src="/assets/img/location{{MapOption == 0 ? '_w' : '_w_0.5'}}.svg" />
                    <span>الموقع</span>
                </li>
                <li 
                    class="border_r label_lg_bold" 
                    [ngClass]="{'active': MapOption == 1}" 
                    (click)="MapOption = 1; AdvertisementCardModel = null; GetPlacesByType('mosque');  setCenterMap()"
                >
                    <img src="/assets/img/service{{MapOption == 1 ? '' : '_w'}}.svg" />
                    <span>الخدمات</span>
                </li>
            </ul>

            <!-- start locatin_alert_rega -->
            <div class="locatin_alert_rega text-center">
                <ng-container *ngIf="this.RegaAdvertisementData?.locationDescriptionOnMOJDeed">
                    <h3 class="sub_title bold font_size_15 lh_none color_black text_under">وصف موقع العقار حسب الصك</h3>
                    <p class="sub_title color_black description mb-2" [innerHTML]="this.RegaAdvertisementData.locationDescriptionOnMOJDeed"></p>
                </ng-container>
                <span class="color_wrong label_lg_bold d-block mb-3 ms-3">
                    نأمل مطابقه الموقع أدناه مع الموقع المذكور في وصف عنوان العقار المكتوب
                </span>
            </div>
            <!-- end locatin_alert_rega -->

        </div>
        <div class="wrap_map container">

            <!-- // MapOption = 1 -->
            <ng-container *ngIf="MapOption == 0 ">
                <div class="wrap_maps_tabs large text-center">
                    <ul class="list_none">
                        <li class="border_r label_lg_bold active">
                            متوسط السعر
                            {{AdvertisementData?.theAverage | shortCurrency}}
                            <i 
                                *ngIf="AdvertisementData?.theAverage != AdvertisementData?.price"
                                [class]="'fa-solid fa-arrow-trend-' + (AdvertisementData?.priceAvg == BLOCK_DIRECTION.up ? 'up' : 'down')"
                            >
                            </i>
                        </li>
                    </ul>
                </div>
            </ng-container>            

            <!-- // MapOption = 1 -->
            <ng-container *ngIf="MapOption == 1">
                <div class="wrap_maps_tabs large text-center">
                    <ul class="list_none">
                        <li 
                            (click)="GetPlacesByType(place.type)" 
                            *ngFor="let place of PlacesType"
                            class="border_r label_lg_bold pointer" 
                            [ngClass]="{'active': place.type == PlaceType}"
                        >
                            {{place.name}}
                        </li>
                    </ul>
                </div>
            </ng-container>

            <div class="position-relative">
                
                <!-- // import app-loader -->
                <app-loader [preventScroll]="true" [sm]="true" size="fa-8x" *ngIf="IsLoading"></app-loader>

                <google-map  
                    id="Agm_map"
                    width="100%"
                    height="660px"                    
                    [center]="Coords"
                    [options]="googleMapsOptions"
                    (mapInitialized)="Map = $event"
                >
                    <!-- // MapOption = 0 -->
                    <map-marker 
                        [position]="Coords"                        
                        [options]="markerOptions"
                        #markerOption_1="mapMarker"
                    >
                        <app-map-info-window [marker]="markerOption_1" [options]="{disableAutoPan: false, content: contentOption_1}">
                            <div class="custom_marker main" #contentOption_1>
                                <div class="text_md_bold text">
                                    <img src="/assets/img/home.svg" />
                                </div>
                            </div>
                        </app-map-info-window>
                    </map-marker>
    
                    <!-- // MapOption = 1 -->
                    <ng-container *ngIf="MapOption == 1 && !IsLoading">
                        <ng-container *ngIf="Places.length > 0">
                            <map-marker 
                                [title]="place?.name"
                                [options]="markerOptions"
                                #markerOption_2="mapMarker"
                                *ngFor="let place of this.Places; let i = index"
                                [position]="{lat: place?.geometry?.location?.lat, lng: place?.geometry?.location?.lng}"
                            >
                            <app-map-info-window [marker]="markerOption_2" [options]="{disableAutoPan: false, content: contentOption_2}">
                                <div 
                                    @DownFromTop 
                                    #contentOption_2
                                    class="custom_marker_place text-center  d-flex justify-content-center align-items-center"
                                >
                                    <div class="text_md_bold text">
                                        <container [ngSwitch]="PlaceType">
                                            <i class="fas fa-ambulance fa-lg color_white" *ngSwitchCase="'hospital'"></i>
                                            <i class="fas fa-mosque fa-lg color_white" *ngSwitchCase="'mosque'"></i>
                                            <i class="fas fa-graduation-cap fa-lg color_white" *ngSwitchCase="'school'"></i>
                                            <i class="fas fa-store-alt fa-lg color_white" *ngSwitchCase="'store'"></i>
                                            <i class="fas fa-train fa-lg color_white" *ngSwitchCase="'train_station'"></i>
                                            <i class="fas fa-bus-alt fa-lg color_white" *ngSwitchCase="'bus_station'"></i>
                                            <i class="fas fa-utensils fa-lg color_white" *ngSwitchCase="'restaurant'"></i>
                                        </container>
                                    </div>
                                </div>
                            </app-map-info-window>
                            </map-marker>
                        </ng-container>
                    </ng-container>
    
                    <!-- // MapOption = 2 -->
                    <ng-container *ngIf="MapOption == 2">
                        <ng-container *ngIf="listOfAdsCompare.length > 0">
                            <ng-container *ngFor="let ad of listOfAdsCompare; let i = index">
                                <map-marker 
                                    #markerOption_3="mapMarker"
                                    [options]="markerOptions"
                                    *ngIf="AdvertisementData?.id != ad?.id"
                                    [position]="{lat: ad?.lat, lng: ad?.lng}"                                      
                                >
                                    <app-map-info-window [marker]="markerOption_3" [options]="{disableAutoPan: false, content: contentOption_3}">
                                        <div 
                                            #contentOption_3
                                            (click)="GetAdvertisementData(ad)"
                                            class="custom_marker compare pointer"
                                        >
                                            <div class="text_md_bold text">
                                                <span 
                                                    *ngIf="ad?.price"
                                                    class="color_white a_none d-block" 
                                                >
                                                    {{ad?.price | shortCurrency}}
                                                </span>
                                            </div>
                                        </div>
                                    </app-map-info-window>
                                </map-marker>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                </google-map> 
            </div>
            <div id="custom_model">
                <app-info-card-model 
                     @fade
                    *ngIf="AdvertisementCardModel" 
                    [data]="AdvertisementCardModel" 
                    [submitView]="true" 
                    (CloseModel)="AdvertisementCardModel = $event" 
                >
                </app-info-card-model>
            </div>            
        </div>
    </div>
</div>